import { render, staticRenderFns } from "./ProprietorRegistration.vue?vue&type=template&id=7e5b001c&scoped=true"
import script from "./ProprietorRegistration.vue?vue&type=script&lang=js"
export * from "./ProprietorRegistration.vue?vue&type=script&lang=js"
import style0 from "./ProprietorRegistration.vue?vue&type=style&index=0&id=7e5b001c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5b001c",
  null
  
)

export default component.exports